/**
 * Cloud Spend Hook
 * TanStack Query hook for fetching cloud spend data
 */

import { useQuery } from '@tanstack/react-query';
import { getCloudSpend } from '../api';

/** Query key factory */
export const cloudSpendKeys = {
  all: ['cloud-spend'] as const,
  summary: () => [...cloudSpendKeys.all, 'summary'] as const,
};

/**
 * Hook to fetch cloud spend data
 * Refreshes every 5 minutes
 */
export function useCloudSpend() {
  return useQuery({
    queryKey: cloudSpendKeys.summary(),
    queryFn: getCloudSpend,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
  });
}
